import { computed } from 'vue';
import {
  VisualStyle,
  type SkinDestination,
  UnderLineType,
} from 'data-types-config';

/**
 * useSkinDestination - Destination-specific CSS classes including button and link styles.
 */
export default function useSkinDestination(props: Partial<SkinDestination>) {
  const allClasses = computed(() => {
    const underlineMap = {
      [UnderLineType.Underline]: 'text-decoration-underline',
      [UnderLineType.None]: 'text-decoration-none',
      [UnderLineType.OnHover]: 'text-decoration-hover',
    };

    const isUnderlinedStyle = props.visualStyle === VisualStyle.Underlined;
    const textDecorationKey = props.isUnderLine
      ? props.isUnderLine
      : isUnderlinedStyle
        ? UnderLineType.Underline
        : UnderLineType.OnHover;

    const textDecorationClass =
      underlineMap[textDecorationKey as UnderLineType] || '';

    const buttonClasses = [
      props.context ? 'btn' : '',
      props.context ? `btn-${props.context}` : '',
      props.size ? `btn-${props.size}` : '',
      props.size === 'lg' ? 'text-uppercase' : '',
      props.isBlock ? 'w-100' : '',
    ];

    const linkClasses = [
      textDecorationClass,
      props.linkColor ? `link-${props.linkColor}` : '',
      props.visualStyle ? `link--${props.visualStyle}` : '',
      props.isActive ? 'isActive' : '',
      props.isDisabled ? 'disabled' : '',
    ];

    return [...linkClasses, ...buttonClasses].filter(Boolean).join(' ');
  });

  return {
    allClasses,
  };
}
